import { cn } from '@/lib/utils'

type StripeWordmarkProps = {
  className?: string
}

/**
 * Stripe wordmark as bold lowercase type — scales with surrounding text like the original
 * badge treatment, without the viewBox padding that made the SVG look too small.
 */
export function StripeWordmark({ className }: StripeWordmarkProps) {
  return (
    <span className={cn('font-bold lowercase tracking-tight', className)} aria-label="Stripe">
      stripe
    </span>
  )
}
